<template>
    <div>
        <buttonlist @help="help" ref="SetBtn"></buttonlist>
        <div style="display: flex;background: white">
                <el-upload
                        class="upload-demo"
                        ref="upload"
                        :action="uploadurl"
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :on-change="handleChange"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :file-list="fileList"
                        :limit="1"
                        accept=".xlsx"
                >
                    <el-button slot="trigger" size="mini" type="primary">{{$t('getapi[372]')}}</el-button>
                </el-upload>
                <el-button type="primary" size="mini" @click="confirmImp(0)" style="margin-left: 8px">{{$t('getapi[370]')}}</el-button>
        </div>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left1" ref="left1">
                <div>
                    <div>
                        <el-table
                                id="xpane-0"
                                :data="dataHead"
                                  header-row-class-name="headerclass"
                                  border size="mini"
                                  @row-click="editInfo"
                                  :height="tableHeight1"
                                  style="width: 100%; margin-top:0px">
                            <el-table-column show-overflow-tooltip prop="name" :label="$t('getapi[6388]')"></el-table-column>
                        </el-table>
                    </div>
                    <div>
                        <el-button type="primary" size="mini" @click="batchDel" :disabled="selectData.length < 1">{{$t('getapi[3889]') }}</el-button>
                        <el-table
                                id="xpane-1"
                                :data="dataDate"
                                  header-row-class-name="headerclass"
                                  border size="mini"
                                  :height="tableHeight2"
                                  @selection-change="handleSelectionChange"
                                  style="width: 100%; margin-top:0px">
                            <el-table-column type="selection"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="scheduling_time" :label="$t('getapi[6387]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[410]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[135]')"></el-table-column>
                        </el-table>
                    </div>
                </div>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid1" ref="mid1">
                <div id="xpane-2">
                    <vxe-table :data="dataContent"
                               show-overflow
                               ref='Table'
                               size="mini" :loading="loading"  :height="tableHeight" stripe border resizable>
                        <vxe-table-column show-footer-overflow field="snum" :title="$t('getapi[1297]')" width="50px"></vxe-table-column>
                        <vxe-table-column show-footer-overflow field="projnum" :title="$t('getapi[6389]')" width="100px" ></vxe-table-column>
                        <vxe-table-column show-footer-overflow field="proequipment" :title="$t('getapi[6390]')" width="150px"></vxe-table-column>
                        <vxe-table-column show-footer-overflow field="so_order" :title="$t('getapi[4168]')" width="100px" ></vxe-table-column>
                        <vxe-table-column show-footer-overflow field="partnumber" :title="$t('getapi[2863]')" width="100px"></vxe-table-column>
                        <vxe-table-column show-footer-overflow field="picture" :title="$t('getapi[6391]')" width="100px"></vxe-table-column>
                        <vxe-table-column show-footer-overflow field="opnum" :title="$t('getapi[573]')" width="80px"></vxe-table-column>
                        <vxe-table-column show-footer-overflow field="processstatus" :title="$t('getapi[6392]')" width="150px"></vxe-table-column>
                        <vxe-table-column field="planqty" :title="$t('getapi[2182]')" width="100px" align="right">
                            <template slot-scope="scope">
                                {{scope.row.planqty | thousandth}}
                            </template>
                        </vxe-table-column>
                        <vxe-table-column field="actualqty" :title="$t('getapi[6393]')" width="100px" align="right">
                            <template slot-scope="scope">
                                {{scope.row.actualqty | thousandth}}
                            </template>
                        </vxe-table-column>
                        <vxe-table-column show-footer-overflow field="plancompletiondate" :title="$t('getapi[6162]')" width="150px"></vxe-table-column>
                        <vxe-table-column show-footer-overflow field="unfinishedreason" :title="$t('getapi[6394]')" width="100px"></vxe-table-column>
                        <vxe-table-column show-footer-overflow field="remarks" :title="$t('getapi[6395]')" width="150px"></vxe-table-column>
                        <vxe-table-column show-footer-overflow field="isurgent" :title="$t('getapi[6396]')" width="100px"></vxe-table-column>
                    </vxe-table>
                </div>
            </li>

            <el-dialog v-dialogDrag :visible.sync="isShowDialog" :title="title" width="25%" :close-on-click-modal="false">
                <el-input type="textarea" v-model="content" rows="22" :disabled="true"></el-input>
                <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="isShowDialog = false">{{ $t('getapi[2054]') }}</el-button>
			</span>
            </el-dialog>
        </ul>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: '2_schduling',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight - 150
            },
            tableHeight1(){
                return (this.$windowSize.tableHeight - 150)/2 -150
            },
            tableHeight2(){
                return (this.$windowSize.tableHeight - 150)/2 + 130
            }
        },
        data() {
            return {
                fileList: [],
                uploadurl: '',
                dataDate: [], // 排产日期列表
                dataHead: [], // sheet
                filepath: '',
                dataContent: [], //导入内容
                loading: false,
                selectData: [],
                isShowDialog: false,
                title: '',//标题
                content: '',//内容
                scrollTop:0,
            };
        },
        watch: {
            dataHead: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
            dataDate: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(1)
                })
            },
            dataContent: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(2)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            that.uploadurl = Common.Url + '/Pro/SO/FloorSchdulingImportUpFile?token=' + token;
            that.$limits.dragControllerDiv1();
            that.getDateView()
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6586]"),this.$t("getapi[25]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('');
            },
            leftt(e) {
                var left = document.getElementsByClassName('left1');
                var mid = document.getElementsByClassName('mid1');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            getDateView(){
                let that = this
                that.$http.urlpost('/Pro/SO/GetPro_Shopfloor_Scheduling', that.datajson, function(res) {
                    if (res.Success == 1) {
                        that.dataDate = res.DataContent
                    }
                });
            },
            handleChange(file, fileList) {
                let that = this;
                that.loading = true;
                console.log(file);
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(file.response.Msg);
                    } else {
                        that.filepath = file.response.DataContent.URL
                        that.dataHead = []
                        let arr = file.response.DataContent.SheetList
                        for(let i=0;i<arr.length;i++){
                            that.dataHead = [...that.dataHead,{
                                name: arr[i]
                            }]
                        }
                    }
                    that.loading = false;
                }
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    that.filepath = res.DataContent.URL
                    that.dataHead = []
                    let arr = res.DataContent.SheetList
                    for(let i=0;i<arr.length;i++){
                        that.dataHead = [...that.dataHead,{
                            name: arr[i]
                        }]
                    }
                    that.dataContent = []
                }
                that.fileList=[];
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log("handlePreview"+file);
            },
            editInfo(row){
                let that = this
                let parm = {
                    "filepath": that.filepath,
                    "sheetname": row.name
                }
                that.loading = true
                that.$http.urlpost('/Pro/SO/GetExeclToFloorSchduling', parm, function(res) {
                    if (res.Success == 1) {
                        that.dataContent = res.DataContent.Lists
                    }
                    that.loading = false
                });
            },
            confirmImp(val){
                let that = this
                let parm = {
                    iscontinue: val,
                    list: that.dataContent,
                    LangType: that.$processdata.getLang(),
                }
                that.$http.urlpost('/Pro/SO/FloorSchdulImport', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDateView()
                    }  else if(res.Success > 1){
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.confirmImp(res.Success);
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    } else {
                        that.isShowDialog = true
                        that.title = '错误提示'
                        that.content = that.$processdata.explainCallbackMsg(res.Msg).replaceAll('/r/n','<br/>')
                    }
                });
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectData = val
            },
            batchDel(){
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let arr = []
                        for(let i = 0;i<that.selectData.length;i++){
                            arr = [...arr,{
                                scheduling_no: that.selectData[i].scheduling_no
                            }]
                        }
                        let parm = {
                            list : arr
                        }
                        that.$http.urlpost('/Pro/SO/DelFloorSchdul', parm, function(res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                                that.getDateView()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
